import { useScript } from '@unhead/react';

interface TrustpilotWindow extends Window {
  Trustpilot: {
    loadFromElement: (element: HTMLElement | null, flag: boolean) => void;
  };
}

declare let window: TrustpilotWindow;
const isEnabled = import.meta.env.VITE_ENABLE_TRUSTPILOT === 'true';
export const useTrustpilotScript = (delayMs: number = 3000) => {
  const { onLoaded } = useScript(
    isEnabled
      ? {
          src: 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js',
          crossorigin: undefined,
          referrerpolicy: undefined,
        }
      : {
          src: '',
        }, // Dummy script if not enabled
    {
      key: 'trustpilot-script',
      trigger: isEnabled
        ? new Promise((resolve) =>
            setTimeout(() => {
              resolve();
            }, delayMs)
          )
        : null, // Never trigger if not enabled
    }
  );

  const initializeWidget = (element: HTMLElement | null) => {
    if (isEnabled && window.Trustpilot && element) {
      window.Trustpilot.loadFromElement(element, true);
    }
  };

  return {
    onLoaded,
    initializeWidget,
  };
};
